export default __webpack_public_path__ + "static/media/ketosis_shape@2x.a79e0ce4.jpg";